/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 03.09.2014
 *   Time: 16:55
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { TestEnvironment } from "./TestEnvironment";

export class DevTestEnvironment extends TestEnvironment {
    public static DEV_TEST_ENVIRONMENT_ID: string = "DevTestEnvironment";

    constructor() {
        super(DevTestEnvironment.DEV_TEST_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/branches-test-dev/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/branches-test-dev/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";
    }

    public isSupported(): boolean {
        return this._data.globals.isDevTest;
    }
}
